
<div
    v-if="!visible"
    :class="{'outer': true, 'outer-mobile': viewMode === 'phone'}"
    @mouseover="outerTarget"
    @click="stopProp"
>
  <div
      :class="{'inner': true, 'inner-mobile': viewMode === 'phone'}"
      :style="{'width': computedWidth, 'height':computedHeight}"
      @click="stopProp"
  >
    <template v-for="obj in undoRedoManager.VDom">
      <component :is="obj.node.tag" :key="obj.key" :fb-node="obj.node" v-bind="obj.node.data.props"></component>
    </template>
  </div>
</div>

